module.exports = __webpack_public_path__ + "static/media/user-group.b4da039a.svg";